import React from "react";
import { MessageCircle, Phone, Mail } from "lucide-react";
import { brand } from "../mock";

const FloatingActions = ({ onEnquire }) => (
  <div className="floating-actions">
    <a href={`https://api.whatsapp.com/send?phone=${brand.phoneRaw}&text=Hello,%20Looking%20for%20Eternia,%20Greater%20Noida%20(W).`} target="_blank" rel="noreferrer" className="floating-btn floating-wa" aria-label="WhatsApp">
      <MessageCircle size={22} />
    </a>
    <a href={`tel:${brand.phoneRaw}`} className="floating-btn floating-call" aria-label="Call Now">
      <Phone size={20} />
    </a>
    <button onClick={onEnquire} className="floating-btn floating-enq" aria-label="Enquire">
      <Mail size={20} />
    </button>
  </div>
);

export default FloatingActions;
